import { NameRouteEnum } from './../shared/enum/name-route.enum';
import { StationManagementService } from './station-management.service';
import { Subject } from 'rxjs/Subject';
import { takeUntil } from 'rxjs/operators/takeUntil';
import { filter, map } from 'rxjs/operators';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { Router, NavigationEnd, ActivatedRoute, ActivatedRouteSnapshot } from '@angular/router';

import { Node } from './../sidebar-station/model/node.interface';
import { TabModel } from './components/model/tab-model';
import { TabEnum, TabRouteEnum } from './components/model/tab.enum';
import { SidebarStationService } from '../sidebar-station/sidebar-station.service';

@Component({
  selector: 'app-station-management',
  templateUrl: './station-management.component.html',
  styleUrls: ['./station-management.component.scss']
})
export class StationManagementComponent implements OnInit, OnDestroy {

  pageTitle: string;
  tabsList: TabModel[];
  listStationSideBar: Node[] = [];
  private readonly ngUnsubscribe: Subject<void> = new Subject<void>();


  constructor(
    private titleService: Title,
    private router: Router,
    private readonly sidebarStationService: SidebarStationService,
    private readonly stationManagementService: StationManagementService,
    private activatedRoute: ActivatedRoute
  ) {
    this.titleService.setTitle('SIA (Search, Index, Archive) - Manage Station');
    this.router.navigate([NameRouteEnum.Manage + '/' + TabRouteEnum.Station]);
    this.router.events
      .pipe(
        filter(event => event instanceof NavigationEnd),
        map(() => this.activatedRoute.snapshot),
        map(route => {
          while (route.firstChild) {
            route = route.firstChild;
          }
          return route;
        })
      )
      .subscribe((route: ActivatedRouteSnapshot) => {
        this.pageTitle = route.data.title;
      });
  }

  ngOnInit() {
    this.tabsList = this.getTabList();
    this.sidebarStationService.getObservableSidebarList().pipe(takeUntil(this.ngUnsubscribe)).subscribe(list => {
      this.listStationSideBar = [];
      this.listStationSideBar = list;
    });

  }

  ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.unsubscribe();
  }


  onTabChange(tab: TabModel): void { }

  createEvent() {
    this.stationManagementService.createEvent.emit(true);

  }

  getTabList(): TabModel[] {
    return [
      {
        name: TabEnum.Station,
        route: TabRouteEnum.Station,
        icon: 'settings_input_antenna',
        description: 'Manage Station',
        selected: false
      },
      {
        name: TabEnum.Source,
        route: TabRouteEnum.Source,
        icon: 'source',
        description: 'Manage Source',
        selected: false
      }];
  }

}
